import React, { useEffect, useState } from 'react'
import { renderReadableDate } from '../common/utils'
import styles from './MessageViewer.module.scss'

export const MessageViewer = ({ message, number, created }) => {
  const [parts, setParts] = useState([])

  const splitSmsTexts = newSmsText => {
    setParts(
      newSmsText.split(/(https?.*?)(?=[\n\s])/).map(splitSmsText =>
        splitSmsText.startsWith('http') ? (
          <a
            key={splitSmsText}
            target="_blank"
            href={splitSmsText}
            rel="noreferrer"
          >
            {splitSmsText}
          </a>
        ) : (
          splitSmsText
        ),
      ),
    )
  }

  useEffect(() => {
    if (message) {
      splitSmsTexts(message)
    }
  }, [message])

  if (!message) {
    return <span>no sms</span>
  }

  return (
    <>
      <div className={styles.phone}>
        <label>Number: </label>
        {number}
      </div>
      <div className={styles.created}>
        <label>Created: </label>
        {renderReadableDate(created)}
      </div>

      <div className={styles.sms}>
        {parts[0]}
        {parts[1]}
        {parts[2]}
      </div>
    </>
  )
}
